// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YRlLBUxWFT8nLdD0kS4o{flex-direction:column;flex:1;justify-content:center;width:100%;max-width:628px;margin:0 auto;display:flex}.YRlLBUxWFT8nLdD0kS4o .csXPiVLuH10LxEZSDW7O{flex-direction:row;justify-content:center;gap:8px;display:flex}.YRlLBUxWFT8nLdD0kS4o .Oc4ICTFQCAcE7kkvAcwA{text-align:center;flex-direction:column;display:flex}.YRlLBUxWFT8nLdD0kS4o .AQbd6CsQrlgkt9TX2Wkg{border-radius:16px;align-items:flex-end;margin-bottom:40px;display:flex;overflow:hidden}.YRlLBUxWFT8nLdD0kS4o .AQbd6CsQrlgkt9TX2Wkg img{width:100%;height:auto;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"empty": `YRlLBUxWFT8nLdD0kS4o`,
	"actions": `csXPiVLuH10LxEZSDW7O`,
	"title": `Oc4ICTFQCAcE7kkvAcwA`,
	"titlePreview": `AQbd6CsQrlgkt9TX2Wkg`
};
export default ___CSS_LOADER_EXPORT___;
